/**============================================================
*   [Class] パネル型記事スライダー（センター拡大）
============================================================*/
export default class ArchiveCenteredSlider {
  constructor(
    target,
    key,
  )
  {
    this.swiperSlide = target;
    this.swiperKey = key;
    this.swiperSlide.classList.remove('swiper-disabled');
    this.swiperSlide.classList.add('swiper-centered-'+ this.swiperKey);
    this.breakSmNum = 980;

    let swiperSlides = this.swiperSlide.getElementsByClassName('swiper-slide');
    // let slidable = swiperSlides.length > 3;
    this.swiperSlideItemNum = swiperSlides.length * 2;


    this.initSwiper = () => {
      this.mySwiper = new Swiper(this.swiperSlide, {
        slidesPerView: 'auto',
        loop: true,
        loopAdditionalSlides: this.swiperSlideItemNum,
        loopPreventsSlide: true,
        centeredSlides: true,
        pagination: {
          el: '.swiper-centered-'+ key + ' .swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-centered-'+ key + '+ .swiper-button-prev + .swiper-button-next',
          prevEl: '.swiper-centered-'+ key + '+ .swiper-button-prev',
        },
      });
    };

    this.checkSlider = () => {
      //PC
      if(window.innerWidth > this.breakSmNum) {
        if(this.mySwiper) this.mySwiper.destroy(false,true);
      }else {
        if(this.mySwiper) this.mySwiper.destroy(false,true);
        this.initSwiper();
      }
    }

    const mqlCenteredSlider = window.matchMedia('(min-width: ' + this.breakSmNum + 'px)');
    this.checkSlider(mqlCenteredSlider);
    mqlCenteredSlider.addEventListener('change', this.checkSlider, false);


  }
}
